import React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { foodRestrictionsQuery, recipeQuery, sourcesQuery, tagsQuery } from '@/api'
import EditOrCreateRecipe from '@/features/recipes/EditOrCreateRecipe/EditOrCreateRecipe'
import { languagesQuery } from '@/api/languages'
import { adminsAndAmbassadorsQuery } from '@/api/users'
import { useAuth } from '@/auth'

export const Route = createFileRoute('/recipes_/$recipeId')({
  validateSearch: (params: Record<string, unknown>): { lang?: string } => {
    return {
      lang: params.lang as string,
    }
  },
  loader: async ({ context: { queryClient }, params }) => {
    const [recipe, tags, allergens, languages, adminsAndAmbassadors, sources] = await Promise.all([
      queryClient.ensureQueryData(recipeQuery(params.recipeId)),
      queryClient.ensureQueryData(tagsQuery),
      queryClient.ensureQueryData(foodRestrictionsQuery),
      queryClient.ensureQueryData(languagesQuery),
      queryClient.ensureQueryData(adminsAndAmbassadorsQuery),
      queryClient.ensureQueryData(sourcesQuery),
    ])

    return { recipe, tags, allergens, languages, adminsAndAmbassadors, sources }
  },
  gcTime: 0,
  shouldReload: false,
  component: RecipeComponent,
})

function RecipeComponent() {
  const { recipe, tags, allergens, languages, adminsAndAmbassadors, sources } =
    Route.useLoaderData()
  const { lang } = Route.useSearch()
  const { isAdmin } = useAuth()

  return (
    <EditOrCreateRecipe
      authors={isAdmin ? adminsAndAmbassadors : []}
      originalRecipe={recipe}
      tags={tags}
      allergens={allergens}
      languages={languages}
      lang={lang}
      sources={sources}
    />
  )
}
